export function getCookieValue(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(";").shift()

  return null
}

export function normalizeUtmKey(key) {
  return String(key)
    .trim()
    .replace(/\s+/g, "") // remove spaces
    .replace(/[-.]/g, "_") // kebab/dot -> snake
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2") // camel -> snake
    .replace(/__+/g, "_") // collapse multiple underscores
    .toLowerCase()
}

const utmKeyMap = {
  utm_source: "sourceUtm",
  utm_medium: "mediumUtm",
  utm_campaign: "campaignUtm",
  utm_term: "termUtm",
  utm_content: "contentUtm",
  fb_ads_id: "fbAdsId",
  fb_adset_id: "fbAdsetId",
}

export function getUTMParams() {
  const store = window.Alpine.store("data") || {}
  const storeData = (store && store.values) || {}

  const normalizedParams = {}
  for (const [k, v] of Object.entries(storeData)) {
    normalizedParams[normalizeUtmKey(k)] = v
  }

  const formattedParams = {}
  for (const [normalizedKey, outKey] of Object.entries(utmKeyMap)) {
    if (normalizedKey in normalizedParams) {
      formattedParams[outKey] = normalizedParams[normalizedKey]
    }
  }
  return formattedParams
}
